import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from "lodash";
import { formatText } from "helpers/common";
import LoadingSkeleton from "./LoadingSkeleton/Index";

const SortableTable = ({
  indexColumn = true,
  columns,
  data,
  onSort,
  sortColumn,
  sortOrder,
  isLoading,
  noDataMessage = 'No data found',
}) => {
  const handleSort = (column) => {
    if (column.sortable) {
      onSort(column.key, (sortColumn === column.key && sortOrder === "asc") ? "desc" : "asc");
    }
  };

  return (
    <table className="custom-table-layout table table-sm">
      <thead>
        <tr>
          {indexColumn && (
            <th>#</th>
          )}
          {columns.map((column) => (
            <th
              key={column.key}
              onClick={() => handleSort(column)}
              style={{ cursor: column.sortable ? 'pointer' : 'default' }}
              className={`fw-bold ${column.className}`}
            >
              <div className={`${column.sticky ? "sticky-container" : ""}`}>
                {column.label ? column.label : formatText(column.key)}
                {column.sortable && (
                  <i
                    className={`fas fa-${sortColumn === column.key ? sortOrder === 'asc' ? 'sort-up' : 'sort-down' : "sort"}`}
                    style={{ marginLeft: '2px' }}
                  ></i>
                )}
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          Array.from({ length: 6 }).map((_, index) => (
            <tr key={index} className="border-none">
              <td colSpan={columns.length + 1} className="border-0 p-0">
                <LoadingSkeleton
                  className="p-0 pt-3"
                  innerStyle={{ margin: 0 }}
                />
                </td>
            </tr>
          ))
        ):data?.length > 0 ? (
          data.map((item, index) => (
            <tr key={index}>
              {indexColumn && (
                <td>{index + 1}</td>
              )}

              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`${column.className}`}
                >
                  <div className={`${column.sticky ? "sticky-container" : ""}`}>
                    {column.render
                        ? column.render(item, item[column.key])
                        : !isNil(item[column.key])
                          ? item[column.key]
                          : "N/A"
                    }
                  </div>
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td className="text-center" colSpan={columns.length + 1}>{noDataMessage}</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

SortableTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      sortable: PropTypes.bool,
      render: PropTypes.func,
    })
  ).isRequired,
  data: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  sortColumn: PropTypes.string,
  sortOrder: PropTypes.oneOf(['asc', 'desc']),
  onDelete: PropTypes.func.isRequired,
  generateEditPath: PropTypes.func.isRequired,
  noDataMessage: PropTypes.string,
};

export default SortableTable;
